// Modules
import {
  ArrowsDownUp,
  FileText,
  Gift,
  GlobeHemisphereWest,
  GlobeSimple,
  Money,
  PhoneCall,
  UserCircleGear,
  UserSquare,
} from "@phosphor-icons/react";
import { navigate } from "gatsby-link";
import React from "react";
import { getHasLoginStatus } from "../../../utilities/account-service-utils";

// Model: Quick link card
const QuicklinksCard = ({ title, svg, link, icon, className }) => {
  const navigateToQuickLinkorTelecelPlay = (title, link) => {
    if (title.toLowerCase() === "self service" && !link) {
      // console.log("TAKE USER TO DASHBOARD");
      const userIsSigned = getHasLoginStatus();
      if (userIsSigned) {
        navigate("https://play.telecel.com.gh/dashboard/");
      } else {
        navigate("/");
      }
    } else {
      navigate(`${link}`);
    }
  };

  // Render
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        navigateToQuickLinkorTelecelPlay(title, link);
      }}
      aria-label={svg}
      className={`w-full md:h-54 rounded-lg md:overflow-hidden ${
        title === "Careers" ? "col-span-2 md:col-span-1" : ""
      } `}
    >
      <div
        className={`icon-container min-h-full rounded-lg flex items-center justify-center bg-surface_brand border border-border_lighter transition-all hover:bg-gradient-to-r from-brand to-orange_400  pt-8 px-3 md:pt-10 md:px-4 pb-5 md:pb-0 fill-white ${className}}`}
      >
        <div className="flex flex-col items-center justify-center gap-3 md:gap-0">
          <div className="order-last md:order-first text-body_base h-10 px-1 font-bold text-gray_50 text-center">
            {title}
          </div>
          {!!svg && (
            <div className="icon w-20 md:w-49 transition-all">
              {svg === "topup" && <PhoneCall size="" color="" />}
              {svg === "selfService" && <UserCircleGear size="" color="" />}
              {svg === "Bill Payments" && <Money size="" color="" />}
              {svg === "bundle" && <ArrowsDownUp size="" color="" />}
              {svg === "International" && (
                <GlobeHemisphereWest size="" color="" />
              )}
              {svg === "Fixed" && <GlobeSimple size="" color="" />}
              {svg === "Careers" && <UserSquare size="" color="" />}
            </div>
          )}
          {!!icon && (
            <div className="icon w-20 md:w-49 transition-all">{icon}</div>
          )}
        </div>
      </div>
    </button>
  );
};

// Export
export default QuicklinksCard;
